<span [id]="type().id">{{ type().name() }}</span>